export var UC_ACCOUNT_AES_KEY = 'account_setting';
export var UC_ACCOUNT_SETTING_PATH = '/settings/account';
export var UC_URL_PARAMS_APPID_AES_KEY = 'UC_URL_PARAMS_APPID_AES_KEY';
export var UC_URL_PARAMS_APPID_PREFIX = 'appid=';
export default {
  UC_ACCOUNT_AES_KEY: UC_ACCOUNT_AES_KEY,
  UC_ACCOUNT_SETTING_PATH: UC_ACCOUNT_SETTING_PATH,
  UC_URL_PARAMS_APPID_AES_KEY: UC_URL_PARAMS_APPID_AES_KEY,
  UC_URL_PARAMS_APPID_PREFIX: UC_URL_PARAMS_APPID_PREFIX
};